// Extracts a human-readable message from a failed fetch Response.
// The backend returns `{ error: string }` for every error; fall back to
// `message` or the HTTP status when the body is missing or not JSON.
export async function readApiError(res: Response, fallback = 'Request failed'): Promise<string> {
  try {
    const data = await res.clone().json();
    if (data && typeof data === 'object') {
      if (typeof data.error === 'string' && data.error) return data.error;
      if (typeof data.message === 'string' && data.message) return data.message;
    }
  } catch {
    // non-JSON body
  }
  return `${fallback} (${res.status})`;
}
